function phoneNumberFormatter(origenPhone: string): string {
  let phoneFormatted: string = origenPhone;

  phoneFormatted = phoneFormatted.replace(/\D/g, '');
  phoneFormatted = phoneFormatted.replace(/^(\d)/, '($1');
  phoneFormatted = phoneFormatted.replace(/(.{3})(\d)/, '$1) $2');

  if (phoneFormatted.length > 12) {
    phoneFormatted = phoneFormatted.replace(/(.{4})$/, '-$1');
  } else {
    switch(phoneFormatted.length) {
      case 9:
        phoneFormatted = phoneFormatted.replace(/(.{1})$/, '-$1');
        break;
      case 10:
        phoneFormatted = phoneFormatted.replace(/(.{2})$/, '-$1');
        break;
      case 11:
        phoneFormatted = phoneFormatted.replace(/(.{3})$/, '-$1');
        break;
      case 12:
        phoneFormatted = phoneFormatted.replace(/(.{4})$/, '-$1');
        break;
    }
  }
  return phoneFormatted;
}

export default phoneNumberFormatter;